import "./MediaText.scss";
import { define } from "@shared/Lib/registry";
import type { Component } from "@shared/Lib/types";

export class MediaText implements Component {
  readonly el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
    this.init();
  }

  private init(): void {}

  destroy(): void {}
}

define("MediaText", (el) => new MediaText(el));
